<div class = "content-box">
    <div class="heading">
        <i class="fas fa-thin fa-lock" id="usericon"></i>
        <span>Access Denied</span>
    </div>
    <p>
        You don't have permission to access any products.
        Please contact the FLYHT support desk for assistance at support&#64;flyht.com.
    </p>
</div>
